import {
  createOhouseFooterLinkSchema,
  OhouseFooter,
} from '@bucketplace/design-system/bds';
import { gsap } from 'gsap';
import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { Container } from '@/brand/components/landing/RebrandSectionContainer';
import { AnimationComponentRef } from '@/brand/hooks';
import { DOMAINS, OHS_HOST } from '@/common';
import { isInApp } from '@/utils';

export const FooterContainer = forwardRef<AnimationComponentRef>((_, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const config = useMemo(
    () => ({
      steps: [
        {
          target: containerRef,
          from: { opacity: 0, y: 0 },
          to: { opacity: 1, y: 0, duration: 0 },
          position: '>',
        },
        {
          target: containerRef,
          to: {
            duration: 1,
            opacity: 1,
          },
          position: '>',
        },
      ],
      options: {
        trigger: containerRef,
        start: 'top top',
        scrub: false,
        invalidateOnRefresh: true,
        pin: false,
      },
    }),
    [],
  );

  useImperativeHandle(
    ref,
    () => ({
      createTimeline() {
        const tl = gsap.timeline({
          defaults: {
            ease: 'none',
          },
        });
        for (const s of config.steps) {
          const el = s.target?.current;
          if (!el) {
            continue;
          }
          if (s.from) {
            tl.fromTo(el, s.from, s.to, s.position ?? '>');
          } else {
            tl.to(el, s.to, s.position ?? '>');
          }
        }
        return tl;
      },
    }),
    [config.steps],
  );

  if (isInApp()) {
    return null;
  }

  return (
    <Container ref={containerRef} h="fit-content" w="100%">
      <OhouseFooter
        ohouseFooterLinks={createOhouseFooterLinkSchema({
          ohs: OHS_HOST,
          pro: DOMAINS.O2O_PARTNER,
        })}
        css={{ width: '100%' }}
      />
    </Container>
  );
});
